/* global axios */

import ApiClient from '../ApiClient';

class CrmAPI extends ApiClient {
  constructor(app_id) {
    super('integrations/crm', { accountScoped: true });
    this.app_id = app_id;
  }

  getContact(phone) {
    return axios.get(`${this.url}/${this.app_id}/contact?phone=${phone}`);
  }

  getCustomfields() {
    return axios.get(`${this.url}/${this.app_id}/custom_fields`);
  }

  createDeal(data) {
    return axios.post(`${this.url}/${this.app_id}/create_deal`, data);
  }

  getFunnels() {
    return axios.get(`${this.url}/${this.app_id}/funnels`);
  }

  getUsers() {
    return axios.get(`${this.url}/${this.app_id}/users`);
  }

  getProducts(page = 1, limit = 200) {
    return axios.get(
      `${this.url}/${this.app_id}/products?page=${page}&limit=${limit}`
    );
  }

  getLinkedDeal({dealId, name}) {
    const params = `name=${name}${dealId !== undefined ? `&dealId=${dealId}` : ''}`;
    return axios.get(`${this.url}/${this.app_id}/linked_deal?${params}`);
  }

  updateDealStage(data) {
    return axios.put(`${this.url}/${this.app_id}/update_deal_stage`, data);
  }
}

export default CrmAPI;
